module.exports = __webpack_public_path__ + "static/img/o3.c684b21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/owl/o3.jpg
// module id = gP5d
// module chunks = 0